import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::deleteMethod
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{automation}'
*/
export const deleteMethod = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/automation/{automation}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::deleteMethod
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{automation}'
*/
deleteMethod.url = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { automation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.id
        : args.automation,
    }

    return deleteMethod.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::deleteMethod
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{automation}'
*/
deleteMethod.delete = (args: { automation: string | number | { id: string | number } } | [automation: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::undo
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/automation/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::undo
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::undo
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Automation\DeleteAutomationController::undo
* @see app/Http/Controllers/Automation/DeleteAutomationController.php
* @route '/api/automation/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteAutomationController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteAutomationController